import type {
	CoordinationClient,
	EngagementPlatformPluginOptions,
} from '@atlaskit/editor-plugin-engagement-platform';

interface Props {
	options: {
		coordinationClient: CoordinationClient;
	};
}

export function engagementPlatformPluginOptions({
	options,
}: Props): EngagementPlatformPluginOptions {
	return {
		coordinationClient: options.coordinationClient,
	};
}
